<template>
  <div v-if="currentUser !== null">
    <section class="client-listing-area">
      <div class="client-listing-head-fluid">
        <div class="container">
          <div class="client-listing-head">
            <PreviewSearchBar :isReviewer="isReviewer"/>
          </div><!-- ends client-listing-head -->
        </div>
      </div><!-- ends client-listing-head-fluid -->
      <div class="client-listing-detail-fluid">
        <div class="container">
          <div class="client-listing-detail">
              <ApplicantPreviewList />
          </div><!-- ends client-listing-detail -->
        </div>
      </div><!-- ends client-listing-detail-fluid -->
    </section>
  </div>
</template>

<script>
import ApplicantPreviewList from './ApplicantPreviewList.vue'
import PreviewSearchBar from './PreviewSearchBar.vue';
import { mapGetters } from 'vuex';
import { checkIsReviewerAndRedirect } from '@/utils/checkReviewer.js';

export default {
  name: 'ApplicantPreview',
  data(){
    return {
      isReviewer:false
    }
  },
  components: { PreviewSearchBar, ApplicantPreviewList },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser'
    })
  },
  mounted() {
    this.changeBodyBackground();
  },
  beforeRouteEnter(to, from, next) {
    checkIsReviewerAndRedirect('/')
      .then(() => {
        next();
      })
      .catch(() => {
        next();
      });
  }
};
</script>
